import { cn } from "@/lib/utils";

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "default" | "shimmer";
}

function Skeleton({ className, variant = "default", ...props }: SkeletonProps) {
  if (variant === "shimmer") {
    return (
      <div className={cn("rounded-md bg-muted relative overflow-hidden", className)} {...props}>
        <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/10 to-transparent" />
        <div className="h-full bg-muted" />
      </div>
    );
  }
  
  return <div className={cn("animate-pulse rounded-md bg-muted", className)} {...props} />;
}

export { Skeleton };
